/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '@/shared/api/axios-client'
import type { GetCitiesQueryResponse, GetCities400 } from '../entities/GetCities'
import type { RequestConfig, ResponseErrorConfig } from '@/shared/api/axios-client'

function getGetCitiesUrl() {
  return `/cities` as const
}

/**
 * @description Get company cities
 * @summary Get company cities
 * {@link /cities}
 */
export async function getCities(config: Partial<RequestConfig> & { client?: typeof client } = {}) {
  const { client: request = client, ...requestConfig } = config

  const res = await request<GetCitiesQueryResponse, ResponseErrorConfig<GetCities400>, unknown>({
    method: 'GET',
    url: getGetCitiesUrl().toString(),
    ...requestConfig,
  })
  return res.data
}